/**
 * Adds css styles to the help and info pages to fix inline images spacing.
 * Targets the first inline image after a non-empty text.
 */
export function addPageStyles(): void {
	const style = document.createElement("style");
	style.textContent = `
span:not([class*="pageText__inlineImage"]):not(:empty) + [class*="pageText__inlineImage"] {
    margin-left: 3px;
}
`;

	document.head.appendChild(style);
}
